import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const loader = () =>
  import(/* webpackChunkName: "4-feat-teams-live-persona-card" */ './TeamsLivePersonaCardErrorBoundary');

export default lazyLoadOnRender({ loader });
